import React, { Component } from 'react';
import { get, isNull, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioImageButton from '../../../shared/items/controls/radioImageButton';
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import BodyZoneNextStepButton from "./bodyZoneNextStepButton"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { bodyZoneData } from "./static.bodyZoneData"
import { steps } from "../../../shared/static.steps"
import locales from "./../../../content.json"

import "./../../../shared/services/service.step.scss"

class BodyZone extends Component {
  constructor() {
    super();

    this.state = {
      isOpenBodyZone: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.bodyZone) && !this.state.isOpenBodyZone)
      this.setState({ isOpenBodyZone: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData, onClearStep } = this.props
    const { isOpenBodyZone } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.bodyZone,
      isOpen: isOpenBodyZone,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenBodyZone && !has(data, ["bodyZone"]))
      onSetStepData("bodyZone")

    //clear value if change sex value param
    if (
      get(prevProps, ["data", "sex", "value"]) !== get(data, ["sex", "value"])
      && get(data, ["bodyZone", "isValid"], false)
    )
      onClearStep("bodyZone")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenBodyZone: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenBodyZone } = this.state
    const sexBodyZoneData = !isNull(get(data, ["sex", "value"], null))
      ? bodyZoneData[data.sex.value]
      : bodyZoneData.male

    const params = {
      className: "wrapperBodyZone",
      currentIndex: currentIndex,
      stepIndex: steps.bodyZone,
    }

    return isOpenBodyZone ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].zones_ask}</FirstTitle>

          {
            Object.keys(sexBodyZoneData).map((key, index) => {
              return (
                <RadioImageButton
                  key={index}
                  image={sexBodyZoneData[key].image}
                  isChecked={get(data, ["bodyZone", key], false)}
                  onClick={
                    !get(data, ["bodyZone", key], false)
                      ? onUpdateStepData.bind(this, "bodyZone", key, true)
                      : onUpdateStepData.bind(this, "bodyZone", key, false)
                  }
                >
                  {sexBodyZoneData[key].title}
                </RadioImageButton>
              )
            })
          }
        </StepContentWrapper>

        <StepControl>
          <BodyZoneNextStepButton>{locales[window.userLang].continue}</BodyZoneNextStepButton>
        </StepControl>
      </div>
      : null
  }
}

export default withStepsState(BodyZone);